import * as Yup from "yup";
import {Values} from "Tools/Values";

export const getAliasNameItemValidationSchema = (uniquenessValidator: (fieldName: string) => any) => {
    return Yup.object().shape({
        name: Yup.string().required(() => {
            return Values.getLocalizationValue("fieldRequired");
        }).test("isNameExists", Values.getLocalizationValue("nameAlreadyExists"), uniquenessValidator("name")),
        fullName: Yup.string().required(() => {
            return Values.getLocalizationValue("fieldRequired");
        })
    });
}

export const aliasNameItemValidationSchema = Yup.object().shape({
    name: Yup.string().required(() => {
        return Values.getLocalizationValue("fieldRequired");
    }),
    fullName: Yup.string().required(() => {
        return Values.getLocalizationValue("fieldRequired");
    })
});

export const personPositionValidationSchema = Yup.object().shape({
    positionId: Yup.string().required(() => {
        return Values.getLocalizationValue("fieldRequired");
    }),
    locationId: Yup.string().required(() => {
        return Values.getLocalizationValue("fieldRequired");
    })
});


export const validate = (data: any, schema: any) => {
    const errors: any = {};
    let isValid: boolean = true;
    try {
        schema.validateSync(data, { abortEarly: false });
    } catch (err) {
        isValid = false;
        err.inner.forEach((x: any) => {
            errors[x.path] = x.message;
        });
    }
    return { isValid, errors };
}

export const validateItems = (items: Array<any>, schema: any): { valid: boolean, items: Array<any> } => {
    let hasErrors = false;
    const _items = [ ...items.map(x => { return { ...x }}) ];
    _items.forEach((x) => {
        const { isValid, errors } = validate(x.fields, schema);
        if (isValid) {
            x.errors = {};
        } else {
            hasErrors = true;
            x.errors = errors;
        }
    });
    return { valid: !hasErrors, items: _items };
}
